export default "https://cdn.questicon.mathletics.com/assets/images/Grinning Face-d5bbeba07d2ec5696ab67eedc302d135.svg";